import React from "react";
import AccordionSummary from "@mui/material/AccordionSummary";
import {
  Accordion,
  IconButton,
  Card,
  Typography,
  Tooltip,
  Stack,
} from "@mui/material";
import Div from "@jumbo/shared/Div";
import { useTranslation } from "react-i18next";
import EditIcon from "@mui/icons-material/Edit";
import PersonIcon from "@mui/icons-material/Person";
import ListAltIcon from "@mui/icons-material/ListAlt";
import { useNavigate } from "react-router-dom";

const ClientItem = ({ item }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const active = item.active
    ? t("pages.dsokCustomers.active")
    : t("pages.dsokCustomers.inactive");
  return (
    <Card sx={{ mb: 1 }}>
      <Accordion expanded={false} square sx={{ borderRadius: 2 }}>
        <AccordionSummary
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          sx={{
            px: 3,
            flexDirection: "row-reverse",
            "& .MuiAccordionSummary-content": {
              alignItems: "center",
              justifyContent: "space-between",

              "&.Mui-expanded": {
                margin: "12px 0",
              },
            },
            ".MuiAccordionSummary-expandIconWrapper": {
              color: "text.secondary",
              transform: "none",
              height: 28,
              width: 28,
              alignItems: "center",
              justifyContent: "center",
              mr: 1,

              "&.Mui-expanded": {
                transform: "none",
                color: "primary.main",
                borderColor: "primary.main",
              },

              "& svg": {
                fontSize: "1.25rem",
              },
            },
          }}
        >
          <Div sx={{ flex: { xs: "0 1 auto", md: 2 }, flexShrink: 0, px: 1 }}>
            <Typography
              fontSize={"12px"}
              variant={"h6"}
              color={"text.secondary"}
              mb={0.25}
              sx={{
                display: { xs: "none", md: "block" },
              }}
            >
              {t("pages.dsokCustomers.companyName")}
            </Typography>
            <Typography variant={"body1"}>{item.companyName}</Typography>
          </Div>
          <Div
            sx={{
              flex: { xs: "0 2 auto", md: 2 },
              display: { xs: "none", md: "block" },
              flexShrink: 0,
              px: 1,
            }}
          >
            <Typography
              fontSize={"12px"}
              variant={"h6"}
              color={"text.secondary"}
              mb={0.25}
              sx={{
                display: { xs: "none", md: "block" },
              }}
            >
              {t("pages.dsokCustomers.status")}
            </Typography>
            <Typography variant={"body1"}>{active}</Typography>
          </Div>
          <Div
            sx={{
              flex: { xs: "0 2 auto", md: 2 },
              display: { xs: "none", md: "block" },
              flexShrink: 0,
              px: 1,
            }}
          >
            <Typography
              fontSize={"12px"}
              variant={"h6"}
              color={"text.secondary"}
              mb={0.25}
              sx={{
                display: { xs: "none", md: "block" },
              }}
            >
              {t("pages.dsokCustomers.street")}
            </Typography>
            <Typography variant={"body1"}>{item.street}</Typography>
          </Div>
          <Div
            sx={{
              flex: { xs: "0 2 auto", md: 2 },
              display: { xs: "none", md: "block" },
              flexShrink: 0,
              px: 1,
            }}
          >
            <Typography
              fontSize={"12px"}
              variant={"h6"}
              color={"text.secondary"}
              mb={0.25}
              sx={{
                display: { xs: "none", md: "block" },
              }}
            >
              {t("pages.dsokCustomers.city")}
            </Typography>
            <Typography variant={"body1"}>{item.city}</Typography>
          </Div>
          <Div
            sx={{
              flex: { xs: "0 2 auto", md: 2 },
              display: { xs: "none", md: "block" },
              flexShrink: 0,
              px: 1,
            }}
          >
            <Typography
              fontSize={"12px"}
              variant={"h6"}
              color={"text.secondary"}
              mb={0.25}
              sx={{
                display: { xs: "none", md: "block" },
              }}
            >
              {t("pages.dsokCustomers.companyId")}
            </Typography>
            <Typography variant={"body1"}>{item.companyId}</Typography>
          </Div>
          <Div
            sx={{
              flex: { xs: "0 2 auto", md: 1 },
              px: 1,
            }}
          >
            <Typography
              fontSize={"12px"}
              variant={"h6"}
              color={"text.secondary"}
              mb={0.25}
              sx={{
                display: { xs: "none", md: "block" },
              }}
            >
              {t("pages.presentation.actions")}
            </Typography>
            <Div
              sx={{
                display: "flex",
                flex: { direction: "row", flexWrap: "wrap" },
                minWidth: 110,
              }}
            >
              <Div>
                <IconButton
                  size="small"
                  variant={"contained"}
                  onClick={() => navigate(`/customer/dsok/clients/${item._id}`)}
                >
                  <Tooltip title={t("buttons.edit")} placement="top-start">
                    <EditIcon />
                  </Tooltip>
                </IconButton>
                <IconButton
                  size="small"
                  variant={"contained"}
                  onClick={() =>
                    navigate(`/customer/dsok/clients/${item._id}/employees`)
                  }
                >
                  <Tooltip
                    title={t("pages.dsokCustomers.employees.title")}
                    placement="top-start"
                  >
                    <PersonIcon />
                  </Tooltip>
                </IconButton>
                <IconButton
                  size="small"
                  variant={"contained"}
                  onClick={() =>
                    navigate(`/customer/dsok/clients/${item._id}/orders`)
                  }
                >
                  <Tooltip
                    title={t("sidebar.menuItem.dsokOrders")}
                    placement="top-start"
                  >
                    <ListAltIcon />
                  </Tooltip>
                </IconButton>
              </Div>
            </Div>
          </Div>
        </AccordionSummary>
      </Accordion>
    </Card>
  );
};

export default ClientItem;
